import {
  Box,
  Button,
  TextField,
  InputAdornment,
  Typography,
  IconButton,
  Chip,
  CardContent,
  Tooltip,
  Fade,
  CircularProgress,
  Stack,
  Divider,
  Badge,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  alpha,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import RefreshIcon from "@mui/icons-material/Refresh";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Edit as EditIcon, Close as CloseIcon } from "@mui/icons-material";
import { tokens } from "../../theme";
import { useTheme } from "@emotion/react";
import Header from "../../components/Header";
import AnchorTemporaryDrawer from "../../components/Drawer";
import {
  fetchDataEngine,
  fetchDataEngineCustomized,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../Axios/DynamicService";
import { useNavigate } from "react-router-dom";
import {
  DocumentAccessModal,
  UpdateCaseStatusModal,
  AssignTaskModal,
  MarkPaid,
  DistributionViewModal,
  RetailDistributionViewModal,
  AccountSummaryViewModal,
  SummaryViewModal,
  ReceiptViewModal
} from "./Modal";
import { UpdateDataToStore } from "../../store/Actions/CustomAction";
import { Card, CardBody } from "react-bootstrap";
import usePermissions from "../RBAC/PermissionsHook";
import useSubRightPermissionsHook from "../RBAC/SubRightPermissionHook";
import {
  documentManagementUrl,
  inventoryManagementUrl,
  salesManagement,
} from "../../config";
import {
  deleteDocument,
  handleAddMpesaCode,
  handleApproveDisapprovePaymentVoucher,
  handleReverseSaleOrder,
  markTaskDone,
} from "./DynamicFunctions";
import Swal from "sweetalert2";
import SearchIcon from "@mui/icons-material/Search";
import { generateColumnsFromQuery } from "../Axios/DynamicService";
import ButcheryPOS from "../../scenes/POS/butcheryPOS";
import Payment from "../../scenes/POS/components/payment";
import axios from "axios";
import "../Axios/AxiosConfig"; // ensures global session interceptor is registered
import WarehouseDistribution from "../../scenes/SalesManagement/WarehouseDistribution";
import RetailDistribution from "../../scenes/SalesManagement/RetailDistribution";
import { format } from "date-fns";
import ShowMoreDialog from "../DynamicServiceNew/dynamicDialog";
import UnifiedDistribution from "../../scenes/InventoryManagement/Inventory/unifieddistribution";
import { minWidth } from "@mui/system";

const base_file_path = documentManagementUrl.baseFilePath;

const DynamicTable = ({
  title,
  subtitle,
  columns,
  FormComponent,
  FormComponent1,
  query,
  base_url,
  actions,
  DataFromGetBy,
  getRowId,
  ignoreFields,
  unignoredIds,
  filteredData,
  ignoreShowMore,

  // New props for flexibility (parent controls these)
  rows,                // server-side: current page OR client-side full data

  paginationMode = "client",
  pagination = true,
  page = 0,
  pageSize = 25,
  rowCount = 0,
  onPageChange,
  onPageSizeChange,
  checkboxSelection = false,
  onServerAction,
  // 👈 add this line
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isDark = theme.palette.mode === "dark";

  const { hasPermission } = usePermissions();
  const { hasSubRightPermission } = useSubRightPermissionsHook();
  const [data, setData] = useState([]);
  const [filteredServerRows, setFilteredServerRows] = useState(null);

  // Reset filtered rows whenever parent rows change (new search/page from parent)
  React.useEffect(() => {
    setFilteredServerRows(null);
  }, [rows]);

  // compute display rows depending on mode (after data is defined)
  const displayRows = paginationMode === "server"
    ? (filteredServerRows !== null ? filteredServerRows : (rows || []))
    : (data || []);
  const recordCount = paginationMode === "server" ? (rowCount || 0) : (displayRows?.length || 0);

  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const RoleGroupId = parseInt(decodedToken.RoleGroupId);
  const CompanyId = parseInt(decodedToken.CompanyId);
  const UserId = parseInt(decodedToken.Id);

  const [assignDocumentAccessOpen, setAssignDocumentAccessOpen] =
    useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [generatedColumn, setGeneratedColumn] = useState([]);
  const [OpenMarkPaidModal, setOpenMarkPaidModal] = useState(false);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [openPaymentVoucher, setPaymentVoucher] = useState(false);
  const [saleOrderPayments, setSaleOrderPaymentAmount] = useState(0);
  const [selectedSaleOrders, setSelectedSaleOrders] = useState([]);
  const [currentRepaymentOrder, setCurrentRepaymentOrder] = useState(null);

  const [openWarehouseDistributionModal, setOpenWarehouseDistributionModal] =
    useState(false);
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [density, setDensity] = useState("standard");
  const [loading, setLoading] = useState(false);
  const [openRetailDistributionModal, setOpenRetailDistributionModal] = useState(false);
  const [distributionViewOpen, setDistributionViewOpen] = useState(false);
  const [accountSummaryViewOpen, setAccountSummaryViewOpen] = useState(false);
  const [summaryViewOpen, setSummaryViewOpen] = useState(false);
  const [receiptViewOpen, setReceiptViewOpen] = useState(false);
  const [retailDistributionViewOpen, setRetailDistributionViewOpen] =
    useState(false);
  const [unifiedDistributionView, setOpenUnifiedDistributionView] =
    useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [dialogOpenPv, setDialogOpenPv] = useState(false);

  const [distributionViewData, setDistributionViewData] = useState(null);
  const [accountSummaryViewData, setAccountSummaryViewData] = useState(null);
  const [summaryViewData, setSummaryViewData] = useState(null);
  const [receiptViewData, setReceiptViewData] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [paginationData, setPaginationData] = useState({
    currentPage: 0,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
  });
  // Handle previous page
  const handlePreviousPage = () => {
    if (paginationModel.page > 0) {
      setPaginationModel(prev => ({
        ...prev,
        page: prev.page - 1
      }));
    }
  };

  // Handle next page
  const handleNextPage = () => {
    if (paginationData.totalPages && paginationModel.page < paginationData.totalPages - 1) {
      setPaginationModel(prev => ({
        ...prev,
        page: prev.page + 1
      }));
    }
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setPaginationModel(prev => ({
      ...prev,
      pageSize: newPageSize,
      page: 0 // Reset to first page when changing page size
    }));
  };

  const handleOpenMarkPaidModal = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setOpenMarkPaidModal(true);
    setEditData(itemToEdit);
  };
  const handleOpenDistributionModal = async (row, id) => {
    try {

      // Step 1: Find product item
      const itemToEdit = data.find((item) => item.id === id);

      if (!itemToEdit) {
        Swal.fire("Error", "Unable to locate item details.", "error");
        return;
      }

      // Step 2: Retrieve PurchaseOrderData from localStorage
      const purchaseOrderDataStr = localStorage.getItem("PurchaseOrderData");

      if (!purchaseOrderDataStr) {
        Swal.fire(
          "Error",
          "Purchase order data not found in local storage.",
          "error"
        );
        return;
      }

      const purchaseOrderData = JSON.parse(purchaseOrderDataStr);

      const isExternalWarehouse = itemToEdit.isExternalWarehouse;

      const vendorId = purchaseOrderData.vendorId;

      if (!vendorId) {
        Swal.fire(
          "Error",
          "Vendor ID missing in purchase order data.",
          "error"
        );
        return;
      }

      const POData = await fetchDataEngine(
        "purchaseOrderById",
        "purchaseOrder",
        { id: purchaseOrderData.id },
        ["deliveryStatus", "reversed"],
        salesManagement.uri
      );


      if (POData.deliveryStatus === false) {
        Swal.fire(
          "Error",
          "This purchase order has not been delivered, go to purchase orders > Actions > Mark Delivered",
          "error"
        );
        return;
      }

      // Check if purchase order is reversed
      if (POData.reversed === 1 || POData.reversed === true || POData.reversed === "1") {
        Swal.fire(
          "Error",
          "Cannot distribute items from a reversed purchase order.",
          "error"
        );
        return;
      }

      // Check if purchase order item is reversed
      if (row.reversed === 1 || row.reversed === true || row.reversed === "1") {
        Swal.fire(
          "Error",
          "Cannot distribute items from a reversed purchase order item.",
          "error"
        );
        return;
      }

      // Step 3: Fetch vendor info via GraphQL
      const rawToken = localStorage.getItem("token");
      const cleanToken = rawToken ? rawToken.replace(/^"|"$/g, "") : "";

      const vendorQuery = `
      query {
        vendorById(vendor: {id: ${vendorId}}) {
          id
          vendorName
          isInternal
        }
      }
    `;


      const response = await axios.post(
        salesManagement.uri,
        { query: vendorQuery },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cleanToken}`,
          },
        }
      );


      if (response.data.errors) {
        console.error("GraphQL errors:", response.data.errors);
        throw new Error(response.data.errors[0].message);
      }

      const vendor = response.data.data?.vendorById;

      if (!vendor) {
        Swal.fire("Error", "Vendor not found.", "error");
        return;
      }

      // Step 4: Decide modal based on vendor.isInternal and isExternalWarehouse
      if (vendor.isInternal === 1 || vendor.isInternal === true) {
        // For internal vendors, check retail distribution
        if (itemToEdit.isRetailDistributed === 1 || itemToEdit.isRetailDistributed === true || itemToEdit.isRetailDistributed === "1") {
          Swal.fire(
            "info",
            "This item has already been retail distributed 🫷",
            "info"
          );
          return;
        }
        setOpenRetailDistributionModal(true);
        setEditData(itemToEdit);
      } else if (isExternalWarehouse === 1 || isExternalWarehouse === true || isExternalWarehouse === "1") {
        // For external warehouse vendors, check retail distribution
        if (itemToEdit.isRetailDistributed === 1 || itemToEdit.isRetailDistributed === true || itemToEdit.isRetailDistributed === "1") {
          Swal.fire(
            "info",
            "This item has already been retail distributed 🫷",
            "info"
          );
          return;
        }
        setOpenUnifiedDistributionView(true);
        setEditData(itemToEdit);
      } else {
        // For regular external vendors, check warehouse distribution
        if (itemToEdit.isWarehouseDistributed === 1 || itemToEdit.isWarehouseDistributed === true || itemToEdit.isWarehouseDistributed === "1") {
          Swal.fire(
            "info",
            "This item has already been warehouse distributed 🫷",
            "info"
          );
          return;
        }
        setOpenWarehouseDistributionModal(true);
        setEditData(itemToEdit);
      }

    } catch (error) {
      console.error("Error opening distribution modal:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.message || "An error occurred while determining distribution type.",
      });
    }
  };
  const handleOPenPaymentVoucher = () => {
    setPaymentVoucher(true);
    setDrawerOpen(true); // 👈 this actually opens the drawer
  };

  const handleSubmit = async (id) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to submit this document? This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: id,
        };
        const response = await generateAndExecuteMutation(
          actions.submit.inputObjectName,
          mutationData,
          actions.submit.inputSubObjectName,
          base_url
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Document submited successfully.`,
          });
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleRemoveTeamMember = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you  want to remove this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          ids: row.id,
          ...(actions.entity === "Team Assignments" && { userId: row.userId }),
          ...(actions.entity === "Judge Assignments" && {
            userId: row.judgeId,
          }),
          ...(actions.entity === "Court Assignments" && {
            userId: row.courtId,
          }),
          isActive: false,
          modelName: actions.RemoveItem.modelName,
        };

        const response = await generateAndExecuteMutation(
          actions.RemoveItem.inputObjectName,
          mutationData,
          null,
          base_url
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Item removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  useEffect(() => {
    /**
     * Fetches the columns from the query. If the columns are not provided, it generates columns from the query.
     * The generated columns are set to the generatedColumn state.
     */
    function fetchcolumns() {
      if (columns === null || columns === undefined) {
        const columnsData = generateColumnsFromQuery(
          query,
          ignoreFields,
          unignoredIds
        );
        setGeneratedColumn(columnsData);
      } else {
        setGeneratedColumn(columns);
      }
    }
    fetchcolumns();
  }, [columns]);

  /**
   * Removes a leave approver
   * @param {Object} row The row data of the approver to be removed
   * @returns {Promise<void>}
   */
  const MarkIsDelivered = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you  want to mark this order as  delivered}?"`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Mark!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = { purchaseOrderId: row.id };
        const response = await generateAndExecuteMutation(
          actions.markIsDelivered.dataObject.inputObjectName,
          mutationData,
          null,
          base_url
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Item marked successfully.`,
          });
          onServerAction();
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  const ProcessCustomerOutstandingBalance = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you  want to notify the customer on The credit?"`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Mark!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = { customerId: row.id };

        const response = await generateAndExecuteMutation(
          actions.processCustomeBalance.dataObject.inputObjectName,
          mutationData,
          "balanceParams",
          base_url
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Notification was sent successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const MarkIsPaid = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you  want to mark this order as paid?"`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Mark!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = { purchase: row.id };

        const response = await generateAndExecuteMutation(
          actions.markIsVendorPaid.dataObject.inputObjectName,
          mutationData,
          null,
          base_url
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Item marked successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const removeSurrenderLine = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you  want to remove this line?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: row.id,
          applicationId: row.applicationId,
          amount: row.amount,
          description: row.description,
          isActive: 0,
        };
        if (actions.dataObjectForMutation.isSurrenderLine) {
          mutationData.surrenderId = row.surrenderId;
        }

        const response = await generateAndExecuteMutation(
          actions.dataObjectForMutation.inputObjectName,
          mutationData,
          actions.dataObjectForMutation.inputSubObjectName,
          base_url
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Line Removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  /**
   * Handles the activation/deactivation of a given row
   * @param {boolean|number} isActive The current isActive state of the row
   * @param {number} id The ID of the row to activate/deactivate
   * @returns {Promise<void>}
   */
  const handleActivateDeactivate = async (isActive, id, active) => {
    try {
      const actionType =
        isActive === 1 || isActive === true || active === 1 || active === true
          ? "deactivate"
          : "activate";

      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${actionType} ${actions.entity}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${actionType} it!`,
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        let mutationData = null;

        // Prepare the mutation data based on the model name
        if (actions.modelName) {
          mutationData = {
            modelName: actions.activateDeactivate.modelName,
            isActive: !active, // Toggle the current state
            moduleIds: [id], // Wrap the ID in an array as expected by the mutation
          };
        } else if (actions.activateDeactivate.modelName === "voucherId") {
          mutationData = {
            ["id"]: id,
          };
        } else {
          mutationData = {
            [actions.activateDeactivate.modelName]: [id], // Wrap the ID in an array
            isActive: !isActive, // Toggle the current state
          };
        }

        // Execute the mutation
        const response = await generateAndExecuteMutation(
          actions.activateDeactivate.inputObjectName,
          mutationData,
          actions.activateDeactivate.inputSubObjectName,
          base_url
        );

        // Check the response and show success
        if (response && Object.keys(response)[0]) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.entity} ${actionType}d successfully.`,
          });

          // Refresh the table after the operation
          setRefreshTable(true);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          error.response.data.errors[0].message !== ""
            ? error.response.data.errors[0].message
            : "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  /**approve payment voucher */
  const approvePaymentVoucher = async (isactive, id, flag) => {
    try {
      const response = await handleApproveDisapprovePaymentVoucher(
        id,
        actions,
        flag
      );
      if (response && Object.keys(response)[0]) {
            onServerAction();               // parent will re‑fetch data
          
            setRefreshTable(true);          // client‑side re‑fetch
          
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Payment Voucher ${flag === 0 ? "DiApproved" : flag === 3 ? "Reversed" : "Approved"} successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `Approval Unsuccessful.`,
      });
    // Also refresh on error to sync potential state changes
          onServerAction();
          setRefreshTable(true);

    } // Refresh the table to show updated data
    //  setRefreshTable(true);
  };

  const reversesaleOrder = async (id, flag) => {
    try {
      const response = await handleReverseSaleOrder(
        id,
        actions,
        flag
      );
      if (response && Object.keys(response)[0]) {
        setRefreshTable(true);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `${flag === 0 ? "Sale Order Item" : "Sale Order"} Reversed successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `Approval Unsuccessful.`,
      });
      setRefreshTable(true);
    } // Refresh the table to show updated data
    // setRefreshTable(true);
  };
  const addMpesaCode = async (id) => {
    try {
      const response = await handleAddMpesaCode(
        id,
        actions
      );
      if (response && Object.keys(response)[0]) {
        setRefreshTable(true);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Mpesa Code added successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `Approval Unsuccessful.`,
      });
      setRefreshTable(true);
    } // Refresh the table to show updated data
    // setRefreshTable(true);
  };
  /**
   *
   * @param {*} isApproved
   * @param {*} id
   * the function handles approval and disapproval of expenseEntries
   */
  const handleApproveDisapprove = async (isCancelled, id) => {
    try {
      const actionType =
        isCancelled === true || isCancelled === 1 ? "deactivate" : "activate";

      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${actionType} ${actions.entity}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${actionType} it!`,
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        let mutationData = null;

        // Prepare the mutation data based on the model name
        if (actions.modelName) {
          mutationData = {
            modelName: actions.activateDeactivate.modelName,
            isActive: !isCancelled, // Toggle the current state
            moduleIds: [id], // Wrap the ID in an array as expected by the mutation
          };
        } else {
          mutationData = {
            [actions.activateDeactivate.modelName]: [id], // Wrap the ID in an array
            isActive: !isCancelled, // Toggle the current state
          };
        }

        // Execute the mutation
        const response = await generateAndExecuteMutation(
          actions.activateDeactivate.inputObjectName,
          mutationData,
          actions.activateDeactivate.inputSubObjectName,
          base_url
        );

        // Check the response and show success
        if (response && Object.keys(response)[0]) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.entity} ${actionType}d successfully.`,
          });

          // Refresh the table after the operation
          setRefreshTable(true);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleActivateDeactivate1 = async (active, id) => {
    try {
      const currentState = active; // Fallback to `active` if `isActive` is undefined

      const actionType =
        currentState === true || currentState === 1 ? "deactivate" : "activate";

      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${active === true || active === 1 ? "deactivate" : "activate"
          } ${actions.entity}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${active === true || active === 1 ? "deactivate" : "activate"
          } it!`,
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        // Prepare mutation data with active state toggled
        const mutationData = {
          [actions.activateDeactivate.modelName]: [id], // Wrap the ID in an array
          isActive: !(active === true || active === 1), // Toggle the active state
        };

        // Perform the mutation
        const response = await generateAndExecuteMutation(
          actions.activateDeactivate1.inputObjectName,
          mutationData,
          actions.activateDeactivate1.inputSubObjectName,
          base_url
        );

        // If the mutation was successful
        if (Object.keys(response)[0]) {
          // Show success message
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.entity} ${active === true || active === 1 ? "deactivated" : "activated"
              } successfully.`,
          });

          // Update the table data to reflect the change
          setRefreshTable((prev) =>
            prev.map((company) =>
              company.id === id
                ? { ...company, active: !active } // Toggle the active state in the table
                : company
            )
          );
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  const handleApproveDisapproveCredit = async (isApproved, id) => {
    try {
      // Show confirmation dialog
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${isApproved ? "Disapprove For Credit" : "Approve For Credit"
          } ${actions.entity}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${isApproved ? "Disapprove " : "Approve"} it!`,
        cancelButtonText: "No, keep it",
      });

      // If user confirms the action
      if (confirmation.isConfirmed) {
        let mutationData = null;

        if (actions.modelName) {
          mutationData = {
            modelName: actions.approveddisapproved.modelName,
            isApproved: !isApproved, // Toggle approval state
            moduleIds: [id], // Send ID in an array as expected
          };
        } else {
          mutationData = {
            [actions.approveddisapproved.modelName]: [id],
            isApproved: !isApproved, // Toggle approval state
          };
        }

        // Execute mutation with the updated approval state
        const response = await generateAndExecuteMutation(
          actions.approveddisapproved.inputObjectName,
          mutationData,
          actions.approveddisapproved.inputSubObjectName,
          base_url
        );

        if (response && Object.keys(response)[0]) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.entity} ${!isApproved ? "Approved" : "Disapproved"
              } successfully.`,
          });

          // Refresh the table to show updated data
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle error case
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleApprove = async (row) => {
    try {
      const isApproveAction = row.statusDescription !== "Approved";
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to approve this ${actions.actionName}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes,  approve  it!`,
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        let mutationData = {
          applicationId: row.id,
          userId: row.userId,
          status: 1,
          // Use the reason if provided
        };

        const response = await generateAndExecuteMutation(
          actions.dataObject.inputObjectName,
          mutationData,
          actions.dataObject.inputSubObjectName,
          base_url
        );

        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.actionName} approved successfully.`,
          });
          // Refresh table after the operation
          setRefreshTable(true);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleReject = async (row) => {
    try {
      const isApproveAction = row.statusDescription !== "Approved";
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to Reject
        this ${actions.actionName}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes,  Reject it!`,
        cancelButtonText: "No, keep it",
        input: "text",
        inputPlaceholder: "Enter the reason for rejection",
        inputValidator: (value) => {
          if (!value) {
            return "You need to provide a reason for rejection!";
          }
        },
      });

      if (confirmation.isConfirmed) {
        let mutationData = {
          applicationId: row.id,
          userId: row.userId,
          status: 2,
          comments: confirmation.value, // Use the reason if provided
        };

        const response = await generateAndExecuteMutation(
          actions.dataObject.inputObjectName,
          mutationData,
          actions.dataObject.inputSubObjectName,
          base_url
        );

        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.actionName}
            rejected
             successfully.`,
          });
          // Refresh table after the operation
          setRefreshTable(true);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleRefresh = () => {
    setRefreshTable(true);
  };

  const handleReversePurchaseOrderItem = async (row) => {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const headers = {
      Authorization: formattedToken,
      "Content-Type": "application/json",
    };

    // 1️⃣ Fetch the Purchase Order using row.purchaseOrderId
    let purchaseOrder = null;
    try {
      const poQuery = `
      query {
        purchaseOrderById(purchaseOrder: { id: ${row.purchaseOrderId} }) {
          id
          deliveryStatus
          companyId
          reversed
        }
      }
    `;

      const poResponse = await axios.post(salesManagement.uri, { query: poQuery }, { headers });
      purchaseOrder = poResponse.data?.data?.purchaseOrderById;

      if (!purchaseOrder) {
        await Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Could not fetch parent Purchase Order.",
        });
        return;
      }
    } catch (err) {
      console.error("Error fetching PO:", err);
      await Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not fetch purchase order details.",
      });
      return;
    }

    // 2️⃣ Prevent reversal if parent PO is not delivered
    if (purchaseOrder.deliveryStatus !== true) {
      await Swal.fire({
        icon: "info",
        title: "Reversal Not Allowed",
        text: "Reversal can only happen for delivered purchase orders.",
        confirmButtonText: "OK",
      });
      return;
    }

    // 3️⃣ Prevent reversal if this item is distributed
    if (row?.isWarehouseDistributed === 1 || row?.isRetailDistributed === 1) {
      await Swal.fire({
        icon: "info",
        title: "Reversal Not Allowed",
        text: "This Purchase Order Item has already been distributed.",
        confirmButtonText: "OK",
      });
      return;
    }

    // 4️⃣ Confirm reversal
    const confirmation = await Swal.fire({
      title: "Confirm Reversal",
      text: `Do you want to reverse this purchase order item? This will adjust stock and set cancellation flags.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reverse it!",
      cancelButtonText: "No, cancel",
    });

    if (!confirmation.isConfirmed) return;

    // 5️⃣ Build mutation payload using fetched companyId (NOT from local storage)
    const mutationData = {
      companyId: purchaseOrder.companyId,
      purchaseOrderId: row.purchaseOrderId,
      purchaseOrderItemId: row.id,
      quantityDifference: row?.quantityDifference ?? 0,
      updatedBy: UserId,
    };

    const mutation = `
    mutation {
      reversePurchaseOrderHybrid(
        reversePurchaseOrder: {
          companyId: ${mutationData.companyId},
          purchaseOrderId: ${mutationData.purchaseOrderId},
          purchaseOrderItemId: ${mutationData.purchaseOrderItemId},
          quantityDifference: ${mutationData.quantityDifference},
          updatedBy: ${mutationData.updatedBy}
        }
      ) {
        companyId
        purchaseOrderId
        purchaseOrderItemId
        quantityDifference
        updatedBy
      }
    }
  `;

    // 6️⃣ Execute mutation
    try {
      const response = await axios.post(salesManagement.uri, { query: mutation }, { headers });

      if (response.data?.data?.reversePurchaseOrderHybrid) {
        setRefreshTable(true);
        Swal.fire({
          icon: "success",
          title: "Reversed!",
          text: "The Purchase Order Item has been successfully reversed.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to reverse the Purchase Order Item.",
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.[0]?.message ||
        error.response?.data?.message ||
        error.message ||
        "Unknown error occurred.";

      Swal.fire({
        icon: "error",
        title: "Error!",
        html: errorMessage.replace(/\r\n/g, "<br>"),
      });
    }
  };



  const handleReversePurchaseOrder = async (row) => {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const headers = {
      Authorization: formattedToken,
      "Content-Type": "application/json",
    };

    // STEP 1️⃣ — Fetch Purchase Order (DO NOT use local storage data anymore)
    let purchaseOrder = null;
    try {
      const query = `
      query {
        purchaseOrderById(purchaseOrder: { id: ${row.id} }) {
          id
          vendorId
          orderDate
          expiryDate
          productCode
          totalAmount
          paymentStatus
          deliveryStatus
          isCredit
          isDistributed
          createdDate
          createdBy
          updatedDate
          updatedBy
          companyId
          regionId
          branchId
          outstandingBalance
          invoiceNumber
          isActive
          vendorComments
          reversed
        }
      }
    `;

      const response = await axios.post(salesManagement.uri, { query }, { headers });
      purchaseOrder = response.data?.data?.purchaseOrderById;

      if (!purchaseOrder) {
        await Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Unable to fetch purchase order details.",
        });
        return;
      }
    } catch (error) {
      console.error("Error fetching PurchaseOrder:", error);
      await Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not fetch purchase order details.",
      });
      return;
    }

    // STEP 2️⃣ — Prevent reversal if not delivered
    if (purchaseOrder.deliveryStatus !== true) {
      await Swal.fire({
        icon: "info",
        title: "Reversal Not Allowed",
        text: "Reversal can only happen for delivered purchase orders.",
      });
      return;
    }

    // STEP 3️⃣ — Fetch PO Items
    let purchaseOrderItems = [];
    try {
      const itemsQuery = `
      query {
        purchaseOrderItemViewById(purchaseOrderItemView: { purchaseOrderId: ${row.id} }) {
          id
          purchaseOrderId
          isWarehouseDistributed
          isRetailDistributed
        }
      }
    `;

      const itemsResponse = await axios.post(salesManagement.uri, { query: itemsQuery }, { headers });
      purchaseOrderItems = itemsResponse.data?.data?.purchaseOrderItemViewById || [];

      if (!Array.isArray(purchaseOrderItems) || purchaseOrderItems.length === 0) {
        await Swal.fire({
          icon: "warning",
          title: "No Items Found",
          text: "This purchase order has no items to reverse.",
        });
        return;
      }
    } catch (err) {
      console.error("Error fetching PO items:", err);
      await Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not verify item distribution.",
      });
      return;
    }

    // STEP 4️⃣ — Check for distributed items
    const hasDistributedItems = purchaseOrderItems.some(
      (item) => item.isWarehouseDistributed === 1 || item.isRetailDistributed === 1
    );

    if (hasDistributedItems) {
      await Swal.fire({
        icon: "info",
        title: "Reversal Not Allowed",
        text: "This Purchase Order contains items that have already been distributed.",
      });
      return;
    }

    // STEP 5️⃣ — Confirm reversal
    const confirmation = await Swal.fire({
      title: "Confirm Reversal",
      text: `Do you want to reverse this purchase order? Stock levels will be adjusted.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reverse it!",
      cancelButtonText: "No, cancel",
    });

    if (!confirmation.isConfirmed) return;

    // STEP 6️⃣ — Use companyId from the fetched PO
    const mutation = `
    mutation {
      reversePurchaseOrderHybrid(
        reversePurchaseOrder: {
          companyId: ${purchaseOrder.companyId},
          purchaseOrderId: ${row.id},
          purchaseOrderItemId: null,
          quantityDifference: ${row?.quantityDifference ?? 0},
          updatedBy: ${UserId}
        }
      ) {
        companyId
        purchaseOrderId
        purchaseOrderItemId
        quantityDifference
        updatedBy
      }
    }
  `;

    try {
      const response = await axios.post(salesManagement.uri, { query: mutation }, { headers });

      if (response.data?.data?.reversePurchaseOrderHybrid) {
        onServerAction();
        Swal.fire({
          icon: "success",
          title: "Reversed!",
          text: "The Purchase Order has been successfully reversed.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to reverse the Purchase Order.",
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.[0]?.message ||
        error.response?.data?.message ||
        error.message ||
        "Unknown error occurred.";

      Swal.fire({
        icon: "error",
        title: "Error!",
        html: errorMessage.replace(/\r\n/g, "<br>"),
      });
    }
  };
  const handleApproveAccountTransfers = async (row) => {
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken") || "{}");
    const currentUserId = parseInt(decodedToken.Id) || null;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Approve?",
      text: `Do you want to approve Transfer #${row.id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          accountTransferId: row.id,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveAccountTransfer",        // 1. Pass the mutation NAME as a string
          mutationData,
          null,            // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url
        );

        if (response && response.approveAccountTransfer.result != -1) {
          Swal.fire({
            icon: "success",
            title: "Sent!",
            text: `Transfer #${row.id} Approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to approve",
            text: response.approveAccountTransfer.errorMessage,
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while approving the Transfer.",
        });
        console.error("Approval error:", error);
      }
    }
  };


  const handleRemoveSaleOrderItem = async (id) => {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const mutationData = {
      companyId: CompanyId,
      removedBy: UserId,
      saleOrderItemId: parseInt(id),
    };

    // Show confirmation alert before proceeding
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to remove this Sale Order Item? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it!",
      cancelButtonText: "No, cancel",
    });

    if (!confirmation.isConfirmed) {
      return; // Exit if user cancels
    }

    const query = `
      mutation {
        removeSaleOrderItem(
          request: { 
            companyId: ${mutationData.companyId}, 
            removedBy: ${mutationData.removedBy}, 
            saleOrderItemId: ${mutationData.saleOrderItemId} 
          }
        ) {
          companyId
          removedBy
          saleOrderItemId
        }
      }
    `;

    const headers = {
      Authorization: formattedToken,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.post(
        salesManagement.uri, // Replace with your actual GraphQL endpoint
        { query },
        { headers }
      );

      if (response.data?.data?.removeSaleOrderItem) {
        setRefreshTable(true);
        Swal.fire({
          icon: "success",
          title: "Removed!",
          text: "The Sale Order Item has been removed successfully.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to remove the Sale Order Item. Please try again.",
        });
      }

      return response.data;
    } catch (error) {
      console.error(
        "Error removing sale order item:",
        error.response?.data || error.message
      );
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  const handleOpenPaymentDialog = (row) => {
    setPaymentDialogOpen(true);
  };

  const handlesetSaleOrderPaymentAmount = (row) => {
    setSaleOrderPaymentAmount(parseInt(row));

  };


  async function fetchData() {
    if (!actions.dataObject) {
      return;
    }
    try {
      const caseIdFromSession = JSON.parse(localStorage.getItem("CaseId"));
      let inputFields = "";
      if (actions.dataObject.inputFields) {
        inputFields = actions.dataObject.inputFields;
      } else {
        inputFields = {
          caseId: caseIdFromSession,
          isActive: true,
        };
      }

      if (actions.dataObject && !actions.dataObject.isDocumentUplod) {
        const data = await fetchDataEngine(
          actions.dataObject.inputObjectName,
          actions.dataObject.inputSubObjectName,
          inputFields,
          actions.dataObject.returnFields,
          base_url
        );

        if (data) {
          setData(data);
        }
      } else if (actions.dataObject.isDocumentUplod) {
        inputFields = {
          caseId: caseIdFromSession,
        };
        const data = await fetchDataEngineCustomized(
          actions.dataObject.inputObjectName,
          actions.dataObject.inputSubObjectName,
          inputFields,
          actions.dataObject.returnFields,
          base_url
        );
        if (data) {
          setData(data);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  useEffect(() => {
    let isMounted = true;

    // Only call fetchData if 'actions.dataObject' exists and 'query' is not present
    if (isMounted && actions.dataObject && !query) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
    // Use dependencies that relate to fetchData's needs, e.g., base_url, actions.dataObject
  }, [base_url, actions.dataObject]);
  useEffect(() => {

    if (refreshTable) {
      if (actions.dataObject && !query) {
        fetchData();
      } else {

      }


      setRefreshTable(false);
    }
  }, [refreshTable]);
  async function fetchAllData() {
    if (paginationMode === "server") {
      console.log("Server-side pagination mode: skipping DynamicTable fetch");
      return;
    }
    try {
      let fetchedData = null;

      if (filteredData && filteredData.length > 0) {
        //fetchedData = await graphqlQuery(query, base_url); // Fetch data from GraphQL API
        fetchedData = filteredData; // 👈 pass variables
        if (refreshTable) {
          fetchedData = await graphqlQuery(query, base_url); // Fetch data from GraphQL API
        }
      } else if (query && !filteredData) {
        fetchedData = await graphqlQuery(query, base_url); // Fetch data from GraphQL API
      } else {
        fetchedData = DataFromGetBy; // Fallback data
      }

      if (fetchedData) {
        setData(fetchedData); // Set the fetched data to state
      } else {
        setData([]); // Set empty data if no data is fetched
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Handle errors
    }
  }
  // async function fetchAllData() {
  //   if (paginationMode === "server") {
  //     console.log("Server-side pagination mode: skipping DynamicTable fetch");
  //     return;
  //   }
  //   // Only show loading for paginated queries

  //   try {
  //     let fetchedData = null;
  //     let paginationInfo = null;

  //     if (filteredData && filteredData.length > 0) {
  //       fetchedData = filteredData;
  //       if (refreshTable) {
  //         fetchedData = await graphqlQuery(query, base_url);
  //       }
  //     } else if (query && !filteredData) {
  //       // Check if this is the paginated sale orders query
  //       if (query.includes("saleOrdersPaginatedFunc")) {
  //         // Extract the pagination parameters from the query
  //         const paginatedQuery = `
  //         query {
  //           saleOrdersPaginatedFunc(functionparams: { 
  //             pageNumber: ${paginationModel.page + 1}, 
  //             pageSize: ${paginationModel.pageSize} 
  //           }) {
  //             branchId
  //             branchName
  //             cancelled
  //             companyId
  //             companyName
  //             createdBy
  //             createdDate
  //             currentPage
  //             customerBalance
  //             customerId
  //             customerName
  //             customerTypeId
  //             firstRecordInPage
  //             int
  //             isCredit
  //             isInvoiced
  //             isPaid
  //             lastRecordInPage
  //             modifiedBy
  //             outstanding
  //             pageSize
  //             paymentMethod
  //             paymentMethodId
  //             phoneNumber
  //             regionId
  //             reversed
  //             saleDate
  //             saleOrderId
  //             salesAgent
  //             totalAmount
  //             totalPages
  //             totalRecords
  //             typeName
  //             updatedBy
  //             updatedDate
  //           }
  //         }
  //       `;

  //         fetchedData = await graphqlQuery(paginatedQuery, base_url);

  //         // Extract pagination metadata from the first item (if available)
  //         if (fetchedData && fetchedData.length > 0) {
  //           const firstItem = fetchedData[0];
  //           setPaginationData({
  //             currentPage: firstItem.currentPage || paginationModel.page + 1,
  //             pageSize: firstItem.pageSize || paginationModel.pageSize,
  //             totalPages: firstItem.totalPages || 0,
  //             totalRecords: firstItem.totalRecords || 0,
  //           });
  //         }
  //       } else {
  //         // For non-paginated queries
  //         fetchedData = await graphqlQuery(query, base_url);
  //       }
  //     } else {
  //       fetchedData = DataFromGetBy; // Fallback data
  //     }

  //     if (fetchedData) {
  //       setData(fetchedData);
  //     } else {
  //       setData([]);f
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     throw error;
  //   } finally {
  //     // Reset loading state
  //     setLoading(false);
  //   }
  // }


  // ✅ FIX: Don't fetch on mount if server mode

  // ✅ FIX: Don't fetch on mount if server mode
  useEffect(() => {
    if (paginationMode === "server") {
      return;
    }
    //  if (query && query.includes("saleOrdersPaginatedFunc")) {
    //       fetchAllData();
    //     }
    let isMounted = true;
    if (isMounted) {
      fetchAllData();
    }
    return () => {
      isMounted = false;
    };
  }, [query, base_url, filteredData, paginationMode, paginationModel.page, paginationModel.pageSize]);

  // ✅ FIX: Don't auto-refresh if server mode (unless explicitly needed)
  useEffect(() => {
    if (refreshTable) {
      // In server mode, trigger parent refetch path explicitly.
      if (paginationMode === "server") {
        if (typeof onServerAction === "function") {
          onServerAction();
        }
        setRefreshTable(false);
        return;
      }

      fetchAllData();
      setRefreshTable(false);
    }
  }, [refreshTable, paginationMode, onServerAction]);

  const filterActionsByRole = (action) => {
    if (actions[action].permission === "hasNoPermission") {
      return actions[action].roleGroupId.includes(RoleGroupId);
    } else if (actions.isSubRight) {
      // For sub-right entities, trust Show_Button as the visibility control.
      // The sub-right RBAC check was blocking buttons when backend permissions
      // were false for the current role, overriding the developer's Show_Button intent.
      return true;
    } else {
      return hasPermission(actions.entity, actions[action].permission);
    }
  };

  const columnsWithActions = [
    ...generatedColumn.map((column) => {
      const dateFields = [
        "initiateddate",
        "approveddate",
        "dateapproved",
        "dateofbirth",
        "createddate",
        "updateddate",
        "lastupdated",
        "expirydate",
        "stockduedate",
        "createdat",
        "yearofestablishment",
        "paymentdate",
        "orderdate",  // FIX 2: PO Order Date column
        "reverseddate",
        "realstockduedate",
        "paidDate",
        "auditDate",
      ];


   if (dateFields.includes(column.field.toLowerCase())) {
  return {
    ...column,
    renderCell: (params) => {
      if (!params.value) return "";

      const date = new Date(params.value);

      if (isNaN(date.getTime())) return params.value;

      const formattedDate = date.toLocaleString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });

      return (
        <Box
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            lineHeight: "normal",
            display: "flex",
            alignItems: "center",
          }}
        >
          {formattedDate}
        </Box>
      );
    },
  };
}
      if (column.field == "externalPaymentStatus") {
        return {
          ...column,

          field: "externalPaymentStatus",
          headerName: "External Payment Status",
          flex: 0.5,
          renderCell: ({ row: { externalPaymentStatus } }) => {
            const statusText = externalPaymentStatus === 1 ? "Paid" : "Pending";
            const statusColor =
              externalPaymentStatus === true || externalPaymentStatus === 1
                ? "green"
                : "red";
            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        };
      }
      if (column.field == "isPaid") {
        return {
          ...column,

          field: "isPaid",
          headerName: "Is Paid",
          flex: 1,
          renderCell: ({ value }) => {
            let statusText = "";
            let statusColor = "";

            switch (value) {
              case 1:
              case true:
                statusText = "Paid";
                statusColor = "green";
                break;
              case 2:
                statusText = "Partially Paid";
                statusColor = "orange";
                break;

              default:
                statusText = "Unpaid";
                statusColor = "red";
                break;
            }

            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        };
      }
      if (column.field == "reversed") {
        return {
          ...column,

          field: "reversed",
          headerName: "Is Reversed",
          flex: 1,
          renderCell: ({ value }) => {
            let statusText = "";
            let statusColor = "";

            switch (value) {
              case 1:
              case true:
                statusText = "True";
                statusColor = "green";
                break;
              default:
                statusText = "False";
                statusColor = "red";
                break;
            }

            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        };
      }
      if (column.field == "isService") {
        return {
          ...column,

          field: "isService",
          headerName: "Is Service",
          flex: 1,
          renderCell: ({ value }) => {
            let statusText = "";
            let statusColor = "";

            switch (value) {
              case 1:
              case true:
                statusText = "True";
                statusColor = "green";
                break;
              default:
                statusText = "False";
                statusColor = "red";
                break;
            }

            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        };
      }
      if (column.field == "pvStatus") {
        return {
          ...column,
          field: "pvStatus",
          headerName: "Payment Status",
          flex: 1,
          renderCell: ({ value }) => {
            let statusText = "";
            let statusColor = "";

            switch (value) {
              case 1:
              case true:
                statusText = "Partially Paid";
                statusColor = "orange"; // 🟠
                break;
              case 2:
                statusText = "Paid";
                statusColor = "green"; // 🟢
                break;

              case 3:
                statusText = "Pending Approval";
                statusColor = "blue"; // 🔵
                break;
              case 4:
                statusText = "Reversed";
                statusColor = "grey";
                break
              default:
                statusText = "Unpaid";
                statusColor = "red"; // 🔴
                break;
            }

            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        };
      }

      if (column.field === "creditApproved") {
        return {
          ...column,
          field: "creditApproved",
          headerName: "Credit Approved",
          flex: 1.5,
          renderCell: ({ row: { creditApproved } }) => {
            if (creditApproved === null || creditApproved === undefined) {
              return <Typography>-</Typography>;
            }

            const isApproved = creditApproved === true;
            const statusText = isApproved ? "Approved" : "Not Approved";
            const statusColor = isApproved ? "green" : "red";

            return (
              <Typography variant="body1" style={{ color: statusColor, fontWeight: 600 }}>
                {statusText}
              </Typography>
            );
          },
        };
      }
      if (column.field === "isSaleAccount") {
        return {
          ...column,
          field: "isSaleAccount",
          headerName: "Sale Acccount",
          flex: 1.5,
          renderCell: ({ row: { isSaleAccount } }) => {
            if (isSaleAccount === null || isSaleAccount === undefined) {
              return <Typography>-</Typography>;
            }

            const isDefault = isSaleAccount === true;
            const statusText = isDefault ? "Default" : "Not Default";
            const statusColor = isDefault ? "green" : "red";

            return (
              <Typography variant="body1" style={{ color: statusColor, fontWeight: 600 }}>
                {statusText}
              </Typography>
            );
          },
        };
      }
      if (column.field === "isSale") {
        return {
          ...column,
          field: "isSale",
          headerName: "Default Acccount",
          flex: 1.5,
          renderCell: ({ row: { isSale } }) => {
            if (isSale === null || isSale === undefined) {
              return <Typography>-</Typography>;
            }

            const isDefault = isSale === 1 || isSale === true;
            const statusText = isDefault ? "Default" : "Not Default";
            const statusColor = isDefault ? "green" : "red";

            return (
              <Typography variant="body1" style={{ color: statusColor, fontWeight: 600 }}>
                {statusText}
              </Typography>
            );
          },
        };
      }



      if (column.field === "id") {
        return {
          ...column,
          renderCell: (params) => params.api.getRowIndex(params.row.id) + 1,
        };
      }

      return {
        ...column,
        renderCell: (params) => (
          <Box
            sx={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              lineHeight: "normal",
              display: "flex",
              alignItems: "center",
            }}
          >
            {params.value}
          </Box>
        ),
      };
    }),
    ...(actions.showStatus !== true
      ? [
        {
          field: "isActive",
          headerName: "Status",
          flex: 0.5,
          renderCell: ({ row: { isActive, pvStatus } }) => {
            const statusText = (() => {
              if (isActive === true || isActive === 1) {
                return actions.showPaymentstatus === true
                  ? "Approved"
                  : "Active";
              } else {
                return actions.showPaymentstatus === true
                  ? pvStatus === 3 ? "Rejected" : "pending"
                  : "Inactive";
              }
            })();
            const statusColor =
              isActive === true || isActive === 1 ? "green" : "red";
            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        },
      ]
      : []),
    ...(actions.showDelivery === true
      ? [
        {
          field: "deliveryStatus",
          headerName: "Delivery Status",
          flex: 0.5,
          renderCell: ({ row: { deliveryStatus } }) => {
            const statusText =
              deliveryStatus === true || deliveryStatus === 1
                ? "Received"
                : "Pending Delivery";
            const statusColor =
              deliveryStatus === true || deliveryStatus === 1
                ? "green"
                : "red";
            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        },
      ]
      : []),

    ...(actions.showPayments === true
      ? [
        {
          field: "paymentStatus",
          headerName: "Payment Status",
          flex: 0.5,
          renderCell: ({ row: { paymentStatus } }) => {
            let statusText = "";
            let statusColor = "";

            switch (paymentStatus) {
              case 1:
              case true:
                statusText = "Partially Paid";
                statusColor = "orange"; // 🟠
                break;
              case 2:
                statusText = "Paid";
                statusColor = "green"; // 🟢
                break;

              case 3:
                statusText = "Pending Approval";
                statusColor = "blue"; // 🔵
                break;
              case 4:
                statusText = "Reversed";
                statusColor = "grey";
                break
              default:
                statusText = "Unpaid";
                statusColor = "red"; // 🔴
                break;
            }
            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        },
      ]
      : []),
    ...(actions.pvPaymentStatus === true
      ? [
        {
          field: "paymentStatus",
          headerName: "Payment Status",
          flex: 0.5,
          renderCell: ({ row: { isActive } }) => {
            let statusText = "";
            let statusColor = "";

            switch (isActive) {
              case 1:
                statusText = "Paid";
                statusColor = "green"; //
                break;

              case 3:
                statusText = "Rejected";
                statusColor = "red"; // 
                break;
              case 5:
                statusText = "Reversed";
                statusColor = "grey"; // ⚪
                break;
              default:
                statusText = "Initial Stages";
                statusColor = "blue"; // 
                break;
            }
            return (
              <Typography variant="body1" style={{ color: statusColor }}>
                {statusText}
              </Typography>
            );
          },
        },
      ]
      : []),

    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      renderCell: ({ row }) => {
        const styledSelectSx = {
          minWidth: 110,
          height: 32,
          backgroundColor: isDark ? '#1e3a5f' : '#eff6ff',
          border: `1px solid #3b82f6`,
          borderRadius: '6px',
          color: '#3b82f6',
          fontWeight: 600,
          fontSize: '13px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          '&:hover': {
            backgroundColor: isDark ? '#2d5a9e' : '#8caedaff',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)',
          },
          '&.Mui-focused': {
            backgroundColor: isDark ? '#1e3a5f' : '#dbeafe',
            boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
          },
          '& .MuiSelect-select': {
            paddingTop: '6px',
            paddingBottom: '6px',
            paddingLeft: '10px',
            paddingRight: '32px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          },
        };

        const styledRenderValue = () => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ fontSize: '14px' }}>⚡</span>
            <span>Actions</span>
          </div>
        );

        const styledIconComponent = (props) => (
          <span {...props} style={{ color: '#3b82f6', fontSize: '12px', right: '8px' }}>▼</span>
        );

        const fieldValue = row[actions.restrict?.field];
        if (actions.restrict?.restrict && fieldValue === actions.restrict?.value) {
          return (
            <Box>
              <Select
                value=""
                displayEmpty
                variant="outlined"
                IconComponent={styledIconComponent}
                sx={styledSelectSx}
                renderValue={styledRenderValue}
                onChange={(e) => handleAction(e.target.value, row.id, row)}
              >
                <MenuItem value="" disabled>
                  <em style={{ color: '#6b7280' }}>Select an action</em>
                </MenuItem>
              </Select>
            </Box>
          );
        } else {
          return (
            <Box>
              <Select
                value=""
                displayEmpty
                variant="outlined"
                IconComponent={styledIconComponent}
                sx={styledSelectSx}
                renderValue={styledRenderValue}
                onChange={(e) => handleAction(e.target.value, row.id, row)}
              >
                <MenuItem value="" disabled>
                  <em style={{ color: '#6b7280' }}>Select an action</em>
                </MenuItem>
                {Object.keys(actions)
                  .filter(
                    (action) =>
                      action !== "add" &&
                      actions[action].Show_Button &&
                      filterActionsByRole(action)
                  )
                  .map((action) => {
                    if (action === "activateDeactivate") {
                      const isRowActive = row.isActive === true || row.isActive === 1 || row.active === 1;
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handleActivateDeactivate(
                              row.isActive,
                              row.id,
                              row.active
                            )
                          }
                          sx={{
                            color: isRowActive ? '#ef4444' : '#10b981',
                            '&:hover': {
                              backgroundColor: isRowActive ? '#fef2f2' : '#f0fdf4',
                            },
                          }}
                        >
                          <span style={{ marginRight: '8px' }}>
                            {isRowActive ? '🔴' : '🟢'}
                          </span>
                          {isRowActive ? "Deactivate" : "Activate"}
                        </MenuItem>
                      );
                    }
                    if (action === "approveddisapproved") {
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handleApproveDisapproveCredit(row.creditApproved)
                          }
                        >
                          {row.creditApproved === true
                            ? "Disapprove For Credit"
                            : "Approve For Credit"}
                        </MenuItem>
                      );
                    }
                    if (action === "approveddisapproved") {
                      return (row.isActive === 0 && (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handleApproveDisapproveCredit(row.creditApproved, 0)
                          }
                        >
                          Disapprove

                        </MenuItem>)
                      );
                    }
                    if (action === "createVoucher") {
                      return ((row.paymentStatus === 0 || row.paymentStatus === 1) && row.deliveryStatus == 1 && (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handleOPenPaymentVoucher()
                          }
                        >
                          Create Payment Voucher
                        </MenuItem>))
                    }
                    if (action === "markIsDelivered") {
                      return (row.deliveryStatus == 0 && (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            MarkIsDelivered(row)
                          }
                        >
                          Mark Delivered
                        </MenuItem>))
                    }
                    if (action === "editpaymentvoucher") {
                      return (row.isActive === 0 && (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handleEdit(row.id)
                          }
                        >
                          Edit
                        </MenuItem>))
                    }
                    if (action === "showMore") {
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handleOpenPaymentVoucherDialog(row)
                          }
                        >
                          Show More
                        </MenuItem>)
                    }
                    if (action === "approveddisapprovedpv") {
                      return (
                        row.isActive === 0 && (
                          <MenuItem
                            key={action}
                            value={action}
                            onClick={() =>
                              approvePaymentVoucher(row.isActive, row.paymentVoucherId, 1)
                            }
                          >
                            Approve
                          </MenuItem>)

                      );
                    }
                    if (action === "disapprovedpv") {
                      return (
                        row.isActive === 0 && (
                          <MenuItem
                            key={action}
                            value={action}
                            onClick={() =>
                              approvePaymentVoucher(row.isActive, row.paymentVoucherId, 0)
                            }
                          >
                            Disapprove
                          </MenuItem>)

                      );
                    }
                    if (action === "reversePaymentVoucher") {
                      return (
                        row.isActive === 1 && (
                          <MenuItem
                            key={action}
                            value={action}
                            onClick={() =>
                              approvePaymentVoucher(row.isActive, row.paymentVoucherId, 3)
                            }
                          >
                            Reverse
                          </MenuItem>)

                      );
                    }
                    if (action === "edit") {
                    const isDistributed =
                      row.isRetailDistributed === 1 ||
                      row.isRetailDistributed === true;

                    if (isDistributed) return null; // hide Edit for this row

                    return (
                      <MenuItem key={actions[action].key} value={action}>
                        {actions[action].button_name}
                      </MenuItem>
                    );
                  }
                    if (action === "payments") {
                      const isPaidValue = row.isPaid;
                      // Show button only when isPaid is 2, 0, null, or undefined
                      const showPaymentButton = isPaidValue === 2 || isPaidValue === 0 || isPaidValue == null;
                      if (!showPaymentButton) return null;
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            handlesetSaleOrderPaymentAmount(row.outstanding)
                          }
                        >
                          Make Payment
                        </MenuItem>
                      );
                    }
                    if (action === "reversesaleOrder") {
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            reversesaleOrder(row, 1)
                          }
                        >
                          ReverseSaleOrder
                        </MenuItem>
                      );
                    }
                    if (action === "reversesaleOrderItem") {
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            reversesaleOrder(row, 0)
                          }
                        >
                          ReverseSaleOrderItem
                        </MenuItem>
                      );
                    }
                    if (action === "addMpesaCode") {
                      return (
                        <MenuItem
                          key={action}
                          value={action}
                          onClick={() =>
                            addMpesaCode(row, 0)
                          }
                        >
                          Add Mpesa Code
                        </MenuItem>
                      );
                    }
                    return (
                      actions[action] && (
                        <MenuItem key={actions[action].key} value={action}>
                          {actions[action].button_name}
                        </MenuItem>
                      )
                    );
                  })}
              </Select>
            </Box>
          )
        };
      },
    },
  ];

  const handleAdd = () => {
    setIsEditing(false);
    setEditData(null);
    if (isMobile) {
      setDialogOpen(true);
    } else {
      setDrawerOpen(true);
    }
  };
  const handleOpenTaskModal = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setTaskModalOpen(true);
    setEditData(itemToEdit);
  };
  const handleAssignDocumentAccessModal = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setAssignDocumentAccessOpen(true);
    setEditData(itemToEdit);
  };
  const handleEdit = (id, row) => {
    const itemToEdit = data.find((item) => item.id === id);
    setEditData(itemToEdit || row);
    setIsEditing(true);
    if (isMobile) {
      setDialogOpen(true);
    } else {
      setDrawerOpen(true);
    }
  };

  const handleOpenPaymentVoucherDialog = (row) => {
    setSelectedItem(row);
    setDialogOpenPv(true);
  };

  const handleClosePaymentVoucherDialog = () => {
    setDialogOpenPv(false);
    setSelectedItem(null);
  };
  const handleOpenDistributionView = (row) => {
    setDistributionViewData(row);
    setDistributionViewOpen(true);
  };
  const handleOpenAccountSummaryView = (row) => {
    setAccountSummaryViewData(row);
    setAccountSummaryViewOpen(true);
  };
  const handleOpenSummaryView = (row) => {
    setSummaryViewData(row);
    setSummaryViewOpen(true);
  };
  const handleOpenReceiptView = (row) => {
    setReceiptViewData(row);
    setReceiptViewOpen(true);
  };
  const handleRetailOpenDistributionView = (row) => {
    setDistributionViewData(row);
    setRetailDistributionViewOpen(true);
  };
  const handleOpenUnifiedDistributionView = (row) => {
    setDistributionViewData(row);
    setOpenUnifiedDistributionView(true);
  };

  const handleAction = async (action, id, row) => {
    switch (action) {
      case "edit":
        //check if the field is approved or not
        if (action.approveddisapprovedpv) {
          handleEdit(id, row);
          break;
        }
      case "editpaymentvoucher":
        //check if the field is approved or not
        handleEdit(id, row);
        break;
      case "approveddisapproved":
        handleApproveDisapproveCredit(row.creditApproved, id);
        break;
      // case "approveddisapprovedpv":
      //   approvePaymentVoucher(row.isActive, row.id, 1);
      //   break;
      // case "disapprovedpv":
      //   approvePaymentVoucher(row.isActive, row.id, 0);
      //   break;
      case "ViewRelievers":
        localStorage.setItem("MyLeaveApplicationsData", JSON.stringify(row));
        navigate("/relievers");
        break;
      case "add":
        handleAdd();
        break;
      case "documentAccess":
        handleAssignDocumentAccessModal(id);
        break;
      case "ViewPurchaseOrderItems":
        localStorage.setItem("PurchaseOrderData", JSON.stringify(row));
        navigate("/pos-purchase-orders-items");
        break;
      case "ViewSaleOrderItems":
        localStorage.setItem("SaleOrderData", JSON.stringify(row));
        navigate("/pos-sales-orders-items");
        break;
      case "ViewReversSaleOrderItems":
        localStorage.setItem("SaleOrderData", JSON.stringify({ ...row, isReversed: true }));
        navigate("/pos-sales-orders-items");
        break;
      case "ViewPaymentMethods":
        localStorage.setItem("SaleOrderData", JSON.stringify(row));
        navigate("/pos-sales-payment-methods");
        break;
      case "ViewPOPaymentMethods":
        localStorage.setItem("PurchaseOrderData", JSON.stringify(row));
        navigate("/pos-purchase-payment-methods");
        break;
      case "ViewCase":
        localStorage.setItem("CaseId", JSON.stringify(id));
        navigate("/case-details");
        break;
      case "AssignTask":
        handleOpenTaskModal(id);
        break;
      case "RemoveSaleOrderItem":
        handleRemoveSaleOrderItem(id);
        break;
      case "ReversePurchaseOrderItem":
        handleReversePurchaseOrderItem(row);
        break;
      case "approveAccountTransafer":
        handleApproveAccountTransfers(row);
        break;
      case "ReversePurchaseOrder":
        handleReversePurchaseOrder(row);
        break;
      case "approve":
        handleApprove(row);
        break;
      case "ViewSurrenderLineByApplication":
        localStorage.setItem("SurrenderId", JSON.stringify(row));
        navigate("/imprest-Surrender-Lines");
        break;
      case "viewStaffClaimsLines":
        localStorage.setItem("claimApplicationId", JSON.stringify(row));
        navigate("/staff-claim-Lines");
        break;
      case "decline":
        handleReject(row);
        break;
      case "markIsDelivered":
        await MarkIsDelivered(row);
        break;
      case "processCustomeBalance":
        await ProcessCustomerOutstandingBalance(row);
        break;
      case "markIsVendorPaid":
        await handleOpenMarkPaidModal(id);
        break;
      case "ViewAccountSummary":
        await handleOpenAccountSummaryView(row);
        break;
      case "ViewSummary":
        await handleOpenSummaryView(row);
        break;
      case "Printreceipt":
        await handleOpenReceiptView(row);
        break;
      case "ViewDistribution":
        await handleOpenDistributionModal(row, id);
        break;
      case "removeSurrenderLine":
        await removeSurrenderLine(row);
        break;
      case "submit":
        await handleSubmit(id);
        break;
      case "RemoveItem":
        await handleRemoveTeamMember(row);
        break;
      case "activateDeactivate":
        handleActivateDeactivate(row.isActive, id);
        break;
      case "activateDeactivate1":
        handleActivateDeactivate1(row.active, id);
        break;

      case "createVoucher":
        localStorage.setItem(
          "purchaseorderid",
          JSON.stringify({
            id: row.id,
            outstandingBalance: row.outstandingBalance,
            vendorid: row.vendorId,
          })
        );
        handleOPenPaymentVoucher();
        break;
      case "ShowDistributionDetails":
        handleOpenDistributionView(row);
        break;
      case "ShowRetailDistributionDetails":
        handleRetailOpenDistributionView(row);
        break;
      case "payments":
        localStorage.setItem("orderId", JSON.stringify(row.saleOrderId)); // Store the orderId in local storage
        handleOpenPaymentDialog(); // Open the payment dialog
         setCurrentRepaymentOrder(row);  
        break;
      case "reversesaleOrder":
        reversesaleOrder(row, 1);
        break;
      case "reversesaleOrderItem":
        reversesaleOrder(row, 0);
        break;
      case "showMore":
        const isPv = row.paymentVoucherId != null;
        handleOpenPaymentVoucherDialog(row);
        break;
      default:
        break;
    }
  };

  const handleSearch = (input) => {
    setSearchTerm(input); // Update searchTerm state

    // Use the generatedColumns if columns is null or undefined
    const activeColumns = columns ?? generatedColumn;

    // Ensure that activeColumns is defined and is an array before filtering
    if (activeColumns && Array.isArray(activeColumns)) {
      if (input.trim() !== "") {
        // In server mode, filter the rows prop instead of internal data
        const sourceData = paginationMode === "server" ? (rows || []) : data;
        const filteredData = sourceData.filter((row) =>
          activeColumns.some((column) => {
            const cellValue = row[column.field];
            return (
              cellValue != null && // avoid null/undefined
              cellValue.toString().toLowerCase().includes(input.toLowerCase())
            );
          })
        );

        if (paginationMode === "server") {
          setFilteredServerRows(filteredData);
        } else {
          setData(filteredData);
        }
      } else {
        if (paginationMode === "server") {
          setFilteredServerRows(null); // Reset to show all rows from parent
        } else {
          setRefreshTable(true); // Reset the table when the search term is cleared
        }
      }
    } else {
      console.error(
        "Columns or generatedColumns are not available for search."
      );
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Enhanced Header Section */}
      <Card
        elevation={0}
        sx={{
          mb: 3,
          background: isDark
            ? colors.primary[400]  // #1F2A40 — matches sidebar navy
            : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          borderRadius: 4,
          overflow: "visible",
          border: isDark ? `1px solid ${colors.blueAccent[700]}` : "none",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems={{ xs: "stretch", md: "center" }}
            justifyContent="space-between"
          >
            {/* Title Section */}
            <Box>
              <Typography
                variant="h4"
                fontWeight="700"
                sx={{
                  color: colors.greenAccent[400],
                  mb: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                {title}
                {/* use displayRows (server) or data (client) so the chip reflects the
                    actual records shown after any search/filter operation */}
                <Chip
                  label={`${(paginationMode === "server"
                    ? rows?.length
                    : data?.length) || 0} records`}
                  size="small"
                  sx={{
                    backgroundColor: alpha(
                      theme.palette.success.main,
                      isDark ? 0.3 : 0.9
                    ),
                    color: isDark
                      ? theme.palette.success.light
                      : theme.palette.success.contrastText,
                    fontWeight: 600,
                    border: isDark
                      ? `1px solid ${theme.palette.success.main}`
                      : "none",
                  }}
                />
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: colors.greenAccent[400],
                }}
              >
                {subtitle}
              </Typography>
            </Box>

            {/* Action Buttons */}
            <Stack direction="row" spacing={1.5} flexWrap="wrap">
              <Tooltip title="Refresh data" arrow>
                <IconButton
                  onClick={handleRefresh}
                  sx={{
                    backgroundColor: alpha(
                      theme.palette.common.white,
                      isDark ? 0.1 : 0.2
                    ),
                    color: colors.greenAccent[400],
                    "&:hover": {
                      backgroundColor: alpha(
                        theme.palette.common.white,
                        isDark ? 0.2 : 0.3
                      ),
                      transform: "rotate(180deg)",
                      transition: "transform 0.3s ease",
                    },
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Export data" arrow>
                <IconButton
                  sx={{
                    backgroundColor: alpha(
                      theme.palette.common.white,
                      isDark ? 0.1 : 0.2
                    ),
                    color: colors.greenAccent[400],
                    "&:hover": {
                      backgroundColor: alpha(
                        theme.palette.common.white,
                        isDark ? 0.2 : 0.3
                      ),
                    },
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>

              {actions.add?.Show_Button && filterActionsByRole("add") && (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => handleAction("add")}
                  sx={{
                    backgroundColor: theme.palette.success.main,
                    color: theme.palette.success.contrastText,
                    fontWeight: 600,
                    borderRadius: 2.5,
                    px: 3,
                    textTransform: "none",
                    boxShadow: `0 4px 14px ${alpha(
                      theme.palette.success.main,
                      0.4
                    )}`,
                    "&:hover": {
                      backgroundColor: theme.palette.success.dark,
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px ${alpha(
                        theme.palette.success.main,
                        0.5
                      )}`,
                    },
                    transition: "all 0.2s ease",
                  }}
                >
                  {actions.add.button_name || "Add New"}
                </Button>
              )}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      {/* Search and Filter Bar */}
      <Card
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 3,
          border: `1px solid ${isDark ? colors.blueAccent[700] : theme.palette.divider}`,
          backgroundColor: isDark ? colors.primary[400] : theme.palette.background.paper,  // #1F2A40 in dark
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems="center"
          >
            {/* Enhanced Search Field */}
            <TextField
              fullWidth
              variant="outlined"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder={`Search ${title}...`}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                  backgroundColor: isDark
                    ? alpha(theme.palette.common.white, 0.05)
                    : alpha(theme.palette.primary.main, 0.04),
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: isDark
                      ? alpha(theme.palette.common.white, 0.08)
                      : alpha(theme.palette.primary.main, 0.08),
                  },
                  "&.Mui-focused": {
                    backgroundColor: isDark
                      ? alpha(theme.palette.common.white, 0.08)
                      : alpha(theme.palette.primary.main, 0.08),
                    boxShadow: `0 0 0 3px ${alpha(
                      theme.palette.primary.main,
                      0.1
                    )}`,
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: theme.palette.text.secondary }} />
                  </InputAdornment>
                ),
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setSearchTerm("")}
                      sx={{ color: theme.palette.text.secondary }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Filter Button */}
            <Tooltip title="Advanced filters" arrow>
              <IconButton
                onClick={(e) => setFilterAnchor(e.currentTarget)}
                sx={{
                  backgroundColor: isDark
                    ? alpha(theme.palette.common.white, 0.05)
                    : alpha(theme.palette.primary.main, 0.04),
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 3,
                  px: 2,
                  "&:hover": {
                    backgroundColor: isDark
                      ? alpha(theme.palette.common.white, 0.1)
                      : alpha(theme.palette.primary.main, 0.08),
                  },
                }}
              >
                <FilterListIcon />
              </IconButton>
            </Tooltip>

            {/* Column Visibility */}
            <Tooltip title="Manage columns" arrow>
              <IconButton
                sx={{
                  backgroundColor: isDark
                    ? alpha(theme.palette.common.white, 0.05)
                    : alpha(theme.palette.primary.main, 0.04),
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 3,
                  px: 2,
                  "&:hover": {
                    backgroundColor: isDark
                      ? alpha(theme.palette.common.white, 0.1)
                      : alpha(theme.palette.primary.main, 0.08),
                  },
                }}
              >
                <ViewColumnIcon />
              </IconButton>
            </Tooltip>
          </Stack>

          {/* Selected Rows Info */}
          {selectedRows.length > 0 && (
            <Fade in>
              <Box
                sx={{
                  mt: 2,
                  p: 1.5,
                  backgroundColor: alpha(
                    theme.palette.info.main,
                    isDark ? 0.15 : 0.1
                  ),
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.text.primary }}
                >
                  <strong>{selectedRows.length}</strong> row(s) selected
                </Typography>
                <Button
                  size="small"
                  onClick={() => setSelectedRows([])}
                  sx={{
                    color: theme.palette.info.main,
                    fontWeight: 600,
                  }}
                >
                  Clear selection
                </Button>
              </Box>
            </Fade>
          )}
        </CardContent>
      </Card>
      {/* Enhanced DataGrid – main change here */}
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          border: `1px solid ${isDark ? colors.blueAccent[700] : theme.palette.divider}`,
          overflow: "hidden",
          backgroundColor: isDark ? colors.primary[400] : theme.palette.background.paper,  // #1F2A40 in dark
        }}
      >{loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress size={48} sx={{ color: theme.palette.primary.main }} />
          <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
            Loading data...
          </Typography>
        </Box>
      ) : displayRows.length === 0 ? (
        // Empty State
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            flexDirection: "column",
            gap: 2,
            py: 4,
          }}
        >
          {/* ... your empty state UI ... */}
        </Box>
      ) : (
        <Box sx={{ height: "70vh" }}>
          <DataGrid
            checkboxSelection
            rows={displayRows}
            columns={columnsWithActions}
            components={{ Toolbar: GridToolbar }}
            getRowId={getRowId}
            density={density}
            onSelectionModelChange={(newSelection) =>
              setSelectedRows(newSelection)
            }
            // ── Server-side pagination configuration ──
            paginationMode={paginationMode}
            pagination={pagination}

            // Only pass these props in server mode
            {...(paginationMode === 'server' && {
              page: page,                    // Use the value directly (0-based)
              pageSize: pageSize,
              rowCount: rowCount,
              onPageChange: onPageChange,
              onPageSizeChange: onPageSizeChange,
              // Disable client-side features
              sortingMode: "client",
              filterMode: "server",
              disableColumnFilter: false,
              disableColumnMenu: false,
            })}

            sx={{
              border: "none",
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: `1px solid ${isDark ? colors.primary[400] : theme.palette.divider}`,
                color: isDark ? colors.grey[100] : theme.palette.text.primary,
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: isDark
                  ? colors.primary[400]   // #1F2A40 — SheriaProFrontend dark nav
                  : alpha(theme.palette.primary.main, 0.08),
                borderBottom: `2px solid ${isDark ? colors.blueAccent[700] : theme.palette.divider}`,
                fontSize: "14px",
                fontWeight: 700,
                color: isDark ? colors.grey[100] : theme.palette.text.primary,
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: isDark ? colors.primary[400] : theme.palette.background.paper,  // #1F2A40 in dark — same as sidebar
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: `2px solid ${isDark ? colors.blueAccent[700] : theme.palette.divider}`,
                backgroundColor: isDark
                  ? colors.primary[400]   // #1F2A40
                  : alpha(theme.palette.primary.main, 0.04),
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: isDark
                    ? alpha(colors.blueAccent[500], 0.15)  // violet-blue tint
                    : alpha(theme.palette.primary.main, 0.04),
                  transform: "scale(1.001)",
                },
              },
              "& .MuiCheckbox-root": {
                color: isDark ? colors.blueAccent[400] : theme.palette.text.secondary,
                "&.Mui-checked": {
                  color: isDark ? colors.blueAccent[400] : theme.palette.primary.main,
                },
              },
              "& .MuiDataGrid-toolbarContainer": {
                padding: "16px",
                backgroundColor: isDark
                  ? colors.primary[400]   // #1F2A40 — matches SheriaProFrontend
                  : alpha(theme.palette.primary.main, 0.04),
                borderBottom: `1px solid ${isDark ? colors.blueAccent[700] : theme.palette.divider}`,
                "& .MuiButton-text": {
                  color: isDark ? colors.greenAccent[400] : theme.palette.text.primary,
                  fontWeight: 600,
                },
              },
            }}
          />

        </Box>
      )}
        {/* Custom Pagination Controls - Only for saleOrdersPaginatedFunc */}
        {query && query.includes("saleOrdersPaginatedFunc") && (
          <Box
            sx={{
              p: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderTop: `1px solid ${theme.palette.divider}`,
              backgroundColor: isDark
                ? alpha(theme.palette.common.white, 0.02)
                : alpha(theme.palette.primary.main, 0.04)
            }}
          >
            {/* Page Info */}
            {/* <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              Page {paginationModel.page + 1} of {paginationData.totalPages || 1}
              | Total records: {paginationData.totalRecords || 0}
            </Typography> */}

            {/* Pagination Controls */}
            <Stack direction="row" spacing={1} alignItems="center">
              {/* Page Size Selector */}
              {/* <Select
                size="small"
                value={paginationModel.pageSize}
                onChange={(e) => handlePageSizeChange(e.target.value)}
                sx={{
                  minWidth: 100,
                  '& .MuiSelect-select': { py: 0.5 }
                }}
              >
                <MenuItem value={10}>10 per page</MenuItem>
                <MenuItem value={25}>25 per page</MenuItem>
                <MenuItem value={50}>50 per page</MenuItem>
                <MenuItem value={100}>100 per page</MenuItem>
              </Select> */}

              {/* Previous Button */}
              {/* <Button
                variant="outlined"
                size="small"
                onClick={handlePreviousPage}
                disabled={paginationModel.page === 0 || loading}
                startIcon={loading && paginationModel.page > 0 ? <CircularProgress size={16} /> : null}
              >
                Previous
              </Button> */}

              {/* Next Button */}
              {/* <Button
                variant="outlined"
                size="small"
                onClick={handleNextPage}
                disabled={
                  !paginationData.totalPages ||
                  paginationModel.page >= paginationData.totalPages - 1 ||
                  loading
                }
                endIcon={loading && paginationModel.page < (paginationData.totalPages - 1) ? <CircularProgress size={16} /> : null}
              >
                Next
              </Button> */}
            </Stack>
          </Box>
        )}

      </Card>
      {OpenMarkPaidModal && (
        <MarkPaid
          data={editData}
          open={OpenMarkPaidModal}
          onClose={() => setOpenMarkPaidModal(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {/* ✅ Render dialog here Opening the payment voucher dialog*/}
      {dialogOpenPv &&

        (
          <ShowMoreDialog
            open={dialogOpenPv}
            onClose={handleClosePaymentVoucherDialog}
            data={selectedItem}
            title={actions.showMore.title}
            ignoreFields={ignoreShowMore ? ignoreShowMore : ignoreFields}
            forceShowFields={actions.showMore?.forceShowFields}
          />
        )}
      {openWarehouseDistributionModal && (
        <WarehouseDistribution
          data={editData}
          open={openWarehouseDistributionModal}
          onClose={() => setOpenWarehouseDistributionModal(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {openRetailDistributionModal && (
        <RetailDistribution
          open={openRetailDistributionModal}
          data={editData}
          onClose={() => setOpenRetailDistributionModal(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {assignDocumentAccessOpen && (
        <DocumentAccessModal
          data={editData}
          open={assignDocumentAccessOpen}
          onClose={() => setAssignDocumentAccessOpen(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {distributionViewOpen && (
        <DistributionViewModal
          itemData={distributionViewData}
          open={distributionViewOpen}
          onClose={() => setDistributionViewOpen(false)}
        />
      )}
      {accountSummaryViewOpen && (
        <AccountSummaryViewModal
          itemData={accountSummaryViewData}
          open={accountSummaryViewOpen}
          onClose={() => setAccountSummaryViewOpen(false)}
        />
      )}
      {summaryViewOpen && (
        <SummaryViewModal
          itemData={summaryViewData}
          open={summaryViewOpen}
          onClose={() => setSummaryViewOpen(false)}
        />
      )}
      {receiptViewOpen && (
        <ReceiptViewModal
          itemData={receiptViewData}
          open={receiptViewOpen}
          onClose={() => setReceiptViewOpen(false)}
        />
      )}
      {retailDistributionViewOpen && (
        <RetailDistributionViewModal //DistributionViewModal
          itemData={distributionViewData}
          open={retailDistributionViewOpen}
          onClose={() => setRetailDistributionViewOpen(false)}
        />
      )}
      {unifiedDistributionView && (
        <UnifiedDistribution //DistributionViewModal
          data={editData}
          open={unifiedDistributionView}
          onClose={() => setOpenUnifiedDistributionView(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {paymentDialogOpen && (
        <Payment
          open={paymentDialogOpen}
          onClose={() => setPaymentDialogOpen(false)}
          onConfirmPayment={() => {
            setPaymentDialogOpen(false);
            setRefreshTable(true);
            // setSnackbarMessage("Payment successful! Thank you.");
            // setSnackbarOpen(true);
          }}
          saleOrderPaymentAmount={saleOrderPayments}
          customerPhone={currentRepaymentOrder?.phoneNumber}
          saleOrderPayment={true}
          onAction={() => setRefreshTable(true)}
          refetchData={() => setRefreshTable(true)}
        />
      )}

      {!openPaymentVoucher ? (
        <AnchorTemporaryDrawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          FormComponent={() => (
            <FormComponent
              isEditing={isEditing}
              data={editData}
              onAction={() => setRefreshTable(true)}
              onServerAction={() => onServerAction?.()}
              onClose={() => setDrawerOpen(false)}
              refetchData={() => setRefreshTable(true)}
            />
          )}
        />
      ) : (
        <AnchorTemporaryDrawer
          anchor="right"
          open={openPaymentVoucher}
          onClose={() => {
            setPaymentVoucher(false);
            setDrawerOpen(false);
          }}
          FormComponent={() => (
            <FormComponent1
              isEditing={isEditing}
              data={editData}
              onAction={() => setRefreshTable(true)}
              onServerAction={() => onServerAction?.()}
              onClose={() => {
                setPaymentVoucher(false);
                setDrawerOpen(false);
              }}
              refetchData={() => setRefreshTable(true)}
            />
          )}
        />
      )}
      ;
      {isMobile && (
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          fullScreen={isMobile}
        >
          <DialogTitle>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDialogOpen(false)}
              aria-label="close"
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FormComponent
              onClose={() => setDialogOpen(false)}
              isEditing={isEditing}
              data={editData}
              onAction={() => setRefreshTable(true)}
              refetchData={() => setRefreshTable(true)}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default DynamicTable;
